import { useIdentity } from '@interhyp/platform-auth';
import { isValidCompanyForInterimOfferTab } from "../functions/isValidCompanyForInterimOfferTab.js";
export function useIsValidCompanyForInterimOfferTab() {
  const identity = useIdentity();
  return isValidCompanyForInterimOfferTab(identity?.companyId);
}